var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlackDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7884 15.135H12.8483V2.85407C12.8483 2.62756 12.7583 2.41032 12.5982 2.25015C12.438 2.08998 12.2208 2 11.9942 2C11.7677 2 11.5505 2.08998 11.3903 2.25015C11.2302 2.41032 11.1402 2.62756 11.1402 2.85407V15.135H7.21144C7.10399 15.1337 6.99864 15.1648 6.90911 15.2243C6.81959 15.2837 6.75002 15.3687 6.70948 15.4682C6.66893 15.5677 6.65929 15.6772 6.68179 15.7822C6.70429 15.8873 6.75791 15.9832 6.83565 16.0574L11.6185 21.8402C11.6683 21.8908 11.7276 21.931 11.7931 21.9584C11.8586 21.9859 11.9289 22 11.9999 22C12.0709 22 12.1412 21.9859 12.2067 21.9584C12.2722 21.931 12.3316 21.8908 12.3814 21.8402L17.1642 16.0574C17.242 15.9832 17.2956 15.8873 17.3181 15.7822C17.3406 15.6772 17.3309 15.5677 17.2904 15.4682C17.2499 15.3687 17.1803 15.2837 17.0908 15.2243C17.0012 15.1648 16.8959 15.1337 16.7884 15.135Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackDown);
export default __webpack_public_path__ + "static/media/black-down.90aadb41a2415d461beedae58db7b20a.svg";
export { ForwardRef as ReactComponent };